/** VIP page copy — PT-BR */
export const vipPt = {
  kicker: 'Apoie o servidor',
  title: 'Planos VIP',
  lead: 'Escolha seu rank, destrave perks exclusivos e ajude o Nexus a continuar épico.',
  close: 'Fechar',
  billingLabel: 'Período de cobrança',
  monthly: 'Mensal',
  annual: 'Anual',
  save20: '-20%',
  mostPopular: 'Mais popular',
  free: 'Grátis',
  perMonth: '/mês',
  perYear: '/ano',
  promo: 'Promoção',
  coupon: 'Cupom',
  yearlySave: 'R$ {{annual}}/ano · economize R$ {{save}}',
  yearlyNet: 'R$ {{net}}/ano',
  yearlyWas: 'de',
  playFree: 'Jogar grátis',
  subscribeNow: 'Assinar agora',
  faqTitle: 'Perguntas frequentes',
  faqLead: 'Tudo que você precisa saber antes de assinar.',
  ctaTitle: 'Ainda com dúvidas?',
  ctaLead: 'Puxa a staff no Discord — a gente te ajuda a escolher o plano certo.',
  ctaDiscord: 'Falar no Discord',
  footerBrand:
    'Vanilla com plugins, economia, clãs e eventos. Comunidade em primeiro lugar.',
  celebrateClose: 'Fechar celebração',
  celebrateKicker: 'Compra confirmada',
  celebrateTitle: 'Parabéns!',
  celebrateConfetti: 'Clique para mais confete!',
  celebrateThanks: 'Obrigado por apoiar o Nexus — você faz a diferença.',
  celebrateAccount: 'Ver minha conta',
  celebrateContinue: 'Continuar',
  celebrateMsgNamed:
    'Seu VIP {{plan}} está liberado. Cargo e rank chegam em instantes.',
  celebrateMsg:
    'Seu VIP está liberado. Cargo e rank chegam em instantes.',
  bannerSuccess:
    'Pagamento confirmado! Cargo e rank serão aplicados em instantes.',
  bannerCancel: 'Checkout cancelado. Você pode tentar de novo quando quiser.',
  bannerReady: 'Discord conectado. Escolha um plano e informe seu nick.',
  bannerPixOk: 'PIX confirmado! Cargo e rank serão aplicados em instantes.',
  bannerPixCopied: 'Código PIX copiado!',
  bannerPixSim:
    'PIX simulado! VIP liberado (só local). Veja em Minha conta.',
  errCopy: 'Não foi possível copiar. Selecione o código manualmente.',
  errConnectSim: 'Conecte seu Discord antes de simular.',
  errNick: 'Nick inválido. Use 3–16 caracteres (letras, números ou _).',
  errSimPix: 'Não foi possível simular o PIX.',
  errConnectPay: 'Conecte seu Discord antes de assinar.',
  errStartPay: 'Não foi possível iniciar o pagamento.',
  errInvalidCode: 'Código inválido',
  modalSubscribe: 'Assinar {{plan}}',
  modalPriceMonth: 'R$ {{price}}/mês',
  modalPriceYear: 'R$ {{price}}/ano',
  modalPixMethod: ' · PIX (Mercado Pago)',
  modalCardMethod: ' · cartão recorrente (Stripe)',
  stepDiscord: '1. Conta Discord',
  stepNick: '2. Nick no Minecraft',
  stepPromo: '3. Cupom ou código de creator (opcional)',
  stepPay: '4. Forma de pagamento',
  switchAccount: 'Trocar',
  connectDiscord: 'Conectar Discord',
  nickPlaceholder: 'SeuNick',
  promoPlaceholder: 'Ex: NEXUS10',
  apply: 'Aplicar',
  creatorPartner: 'Parceria: {{name}}',
  creatorNoExtra: ' (sem desconto extra — venda atribuída)',
  autoPromo: 'Promoção VIP ativa aplicada automaticamente.',
  payCard: 'Cartão',
  payCardHint: 'Stripe · renovação automática',
  payPix: 'PIX',
  payPixHint: 'Mercado Pago · período único',
  pixNote:
    'O PIX cobre o período selecionado. Não há renovação automática.',
  pixNoteLocal: ' Em local você pode simular o pagamento sem cobrança.',
  pixApproved: 'Pagamento aprovado!',
  pixPending: 'Escaneie o QR ou copie o código no app do banco.',
  pixQrAlt: 'QR Code PIX',
  pixCodeAria: 'Código PIX copia e cola',
  copy: 'Copiar',
  pixWaiting: 'Aguardando confirmação… esta tela atualiza sozinha.',
  simLocal: 'Simular PIX pago (local)',
  simLocalShort: 'Simular PIX pago',
  simulating: 'Simulando…',
  closeModal: 'Fechar',
  cancel: 'Cancelar',
  generatingPix: 'Gerando PIX…',
  redirecting: 'Redirecionando…',
  generatePix: 'Gerar PIX',
  goPay: 'Ir para o pagamento',
  plans: {
    free: { name: 'Grátis', tagline: 'Comece a aventura' },
    origin: { name: 'Origin', tagline: 'O equilíbrio perfeito' },
    eclipse: { name: 'Eclipse', tagline: 'Poder de sobra' },
    investidor: { name: 'Investidor', tagline: 'Patrocine o Nexus' },
  },
  feat: {
    'Acesso ao servidor': 'Acesso ao servidor',
    'Pontos de home': 'Pontos de home',
    'Blocos de proteção': 'Blocos de proteção',
    'Anúncios no leilão': 'Anúncios no leilão',
    'Taxa do banco (PIX)': 'Taxa do banco (PIX)',
    'Cofres no banco': 'Cofres no banco',
    'Prefixo no chat': 'Prefixo no chat',
    'Cores e formatação no chat': 'Cores e formatação no chat',
    'Canal VIP': 'Canal VIP',
    'Gradiente na tag do clã': 'Gradiente na tag do clã',
    'Comandos utilitários': 'Comandos utilitários',
    'Efeitos de partícula': 'Efeitos de partícula',
    'Salário diário': 'Salário diário',
    'Prioridade na fila': 'Prioridade na fila',
    'Desconto no baú do clã': 'Desconto no baú do clã',
    'Kit exclusivo': 'Kit exclusivo',
    'Acesso antecipado a eventos': 'Acesso antecipado a eventos',
    'Suporte prioritário': 'Suporte prioritário',
  },
  val: {
    '1 home': '1 home',
    '2 homes': '2 homes',
    '5 homes': '5 homes',
    '15 homes': '15 homes',
    '5.000 blocos · 100/h': '5.000 blocos · 100/h',
    '10.000 blocos · 150/h': '10.000 blocos · 150/h',
    '20.000 blocos · 200/h': '20.000 blocos · 200/h',
    '3 anúncios leilão': '3 anúncios leilão',
    '5 anúncios leilão': '5 anúncios leilão',
    '10 anúncios leilão': '10 anúncios leilão',
    'Taxa PIX 10%': 'Taxa PIX 10%',
    'Taxa PIX 5%': 'Taxa PIX 5%',
    'Taxa PIX 0%': 'Taxa PIX 0%',
    '3 cofres': '3 cofres',
    '4 cofres · juros +0,2%': '4 cofres · juros +0,2%',
    '5 cofres · juros +0,5%': '5 cofres · juros +0,5%',
    'Tag [Origin]': 'Tag [Origin]',
    'Tag [Eclipse]': 'Tag [Eclipse]',
    'Tag [Investidor]': 'Tag [Investidor]',
    '/craft': '/craft',
    '/craft e /ec': '/craft e /ec',
    '/craft, /ec e /anvil': '/craft, /ec e /anvil',
    '1 efeito': '1 efeito',
    '2 efeitos': '2 efeitos',
    '5 efeitos': '5 efeitos',
    'Salário 1.000/dia': 'Salário 1.000/dia',
    'Salário 2.500/dia': 'Salário 2.500/dia',
    'Salário 5.000/dia': 'Salário 5.000/dia',
    'Kit mensal': 'Kit mensal',
    'Kit semanal premium': 'Kit semanal premium',
    '20% no baú do clã': '20% no baú do clã',
    '40% no baú do clã': '40% no baú do clã',
  },
  faq: [
    {
      q: 'Como funciona a renovação?',
      a: 'No cartão (Stripe), a cobrança é recorrente — cancele pelo portal em Minha conta ou pelo Discord. No PIX (Mercado Pago), o pagamento cobre só o período escolhido; renove pelo site antes do vencimento.',
    },
    {
      q: 'Posso mudar de plano?',
      a: 'Sim — fale com a staff no Discord para upgrade ou downgrade.',
    },
    {
      q: 'Quais formas de pagamento?',
      a: 'Cartão via Stripe (renovação automática) ou PIX via Mercado Pago (QR Code / copia e cola).',
    },
    {
      q: 'Os benefícios são imediatos?',
      a: 'Sim. No cartão, após a confirmação do Stripe. No PIX, assim que o pagamento for aprovado (geralmente em segundos).',
    },
  ],
};

/** VIP page copy — EN */
export const vipEn = {
  kicker: 'Support the server',
  title: 'VIP Plans',
  lead: 'Pick your rank, unlock exclusive perks, and help keep Nexus epic.',
  close: 'Close',
  billingLabel: 'Billing period',
  monthly: 'Monthly',
  annual: 'Yearly',
  save20: '-20%',
  mostPopular: 'Most popular',
  free: 'Free',
  perMonth: '/mo',
  perYear: '/yr',
  promo: 'Promo',
  coupon: 'Coupon',
  yearlySave: 'R$ {{annual}}/yr · save R$ {{save}}',
  yearlyNet: 'R$ {{net}}/yr',
  yearlyWas: 'was',
  playFree: 'Play for free',
  subscribeNow: 'Subscribe now',
  faqTitle: 'Frequently asked questions',
  faqLead: 'Everything you need to know before subscribing.',
  ctaTitle: 'Still have questions?',
  ctaLead: 'Ping the staff on Discord — we\'ll help you pick the right plan.',
  ctaDiscord: 'Chat on Discord',
  footerBrand:
    'Vanilla with plugins, economy, clans, and events. Community first.',
  celebrateClose: 'Close celebration',
  celebrateKicker: 'Purchase confirmed',
  celebrateTitle: 'Congratulations!',
  celebrateConfetti: 'Click for more confetti!',
  celebrateThanks: 'Thanks for supporting Nexus — you make a difference.',
  celebrateAccount: 'View my account',
  celebrateContinue: 'Continue',
  celebrateMsgNamed:
    'Your {{plan}} VIP is unlocked. Role and rank arrive in moments.',
  celebrateMsg: 'Your VIP is unlocked. Role and rank arrive in moments.',
  bannerSuccess: 'Payment confirmed! Role and rank will be applied shortly.',
  bannerCancel: 'Checkout canceled. You can try again whenever you like.',
  bannerReady: 'Discord connected. Choose a plan and enter your nick.',
  bannerPixOk: 'PIX confirmed! Role and rank will be applied shortly.',
  bannerPixCopied: 'PIX code copied!',
  bannerPixSim: 'PIX simulated! VIP unlocked (local only). Check My account.',
  errCopy: 'Could not copy. Select the code manually.',
  errConnectSim: 'Connect your Discord before simulating.',
  errNick: 'Invalid nick. Use 3–16 characters (letters, numbers, or _).',
  errSimPix: 'Could not simulate PIX.',
  errConnectPay: 'Connect your Discord before subscribing.',
  errStartPay: 'Could not start payment.',
  errInvalidCode: 'Invalid code',
  modalSubscribe: 'Subscribe to {{plan}}',
  modalPriceMonth: 'R$ {{price}}/mo',
  modalPriceYear: 'R$ {{price}}/yr',
  modalPixMethod: ' · PIX (Mercado Pago)',
  modalCardMethod: ' · recurring card (Stripe)',
  stepDiscord: '1. Discord account',
  stepNick: '2. Minecraft nick',
  stepPromo: '3. Coupon or creator code (optional)',
  stepPay: '4. Payment method',
  switchAccount: 'Switch',
  connectDiscord: 'Connect Discord',
  nickPlaceholder: 'YourNick',
  promoPlaceholder: 'e.g. NEXUS10',
  apply: 'Apply',
  creatorPartner: 'Partner: {{name}}',
  creatorNoExtra: ' (no extra discount — sale attributed)',
  autoPromo: 'Active VIP promo applied automatically.',
  payCard: 'Card',
  payCardHint: 'Stripe · auto-renewal',
  payPix: 'PIX',
  payPixHint: 'Mercado Pago · one period',
  pixNote: 'PIX covers the selected period. There is no auto-renewal.',
  pixNoteLocal: ' Locally you can simulate payment with no charge.',
  pixApproved: 'Payment approved!',
  pixPending: 'Scan the QR or paste the code in your bank app.',
  pixQrAlt: 'PIX QR Code',
  pixCodeAria: 'PIX copy-and-paste code',
  copy: 'Copy',
  pixWaiting: 'Waiting for confirmation… this screen updates on its own.',
  simLocal: 'Simulate paid PIX (local)',
  simLocalShort: 'Simulate paid PIX',
  simulating: 'Simulating…',
  closeModal: 'Close',
  cancel: 'Cancel',
  generatingPix: 'Generating PIX…',
  redirecting: 'Redirecting…',
  generatePix: 'Generate PIX',
  goPay: 'Go to payment',
  plans: {
    free: { name: 'Free', tagline: 'Start the adventure' },
    origin: { name: 'Origin', tagline: 'The perfect balance' },
    eclipse: { name: 'Eclipse', tagline: 'Power to spare' },
    investidor: { name: 'Investor', tagline: 'Sponsor Nexus' },
  },
  feat: {
    'Acesso ao servidor': 'Server access',
    'Pontos de home': 'Home points',
    'Blocos de proteção': 'Protection blocks',
    'Anúncios no leilão': 'Auction listings',
    'Taxa do banco (PIX)': 'Bank fee (PIX)',
    'Cofres no banco': 'Bank vaults',
    'Prefixo no chat': 'Chat prefix',
    'Cores e formatação no chat': 'Chat colors & formatting',
    'Canal VIP': 'VIP channel',
    'Gradiente na tag do clã': 'Clan tag gradient',
    'Comandos utilitários': 'Utility commands',
    'Efeitos de partícula': 'Particle effects',
    'Salário diário': 'Daily salary',
    'Prioridade na fila': 'Queue priority',
    'Desconto no baú do clã': 'Clan chest discount',
    'Kit exclusivo': 'Exclusive kit',
    'Acesso antecipado a eventos': 'Early event access',
    'Suporte prioritário': 'Priority support',
  },
  val: {
    '1 home': '1 home',
    '2 homes': '2 homes',
    '5 homes': '5 homes',
    '15 homes': '15 homes',
    '5.000 blocos · 100/h': '5,000 blocks · 100/h',
    '10.000 blocos · 150/h': '10,000 blocks · 150/h',
    '20.000 blocos · 200/h': '20,000 blocks · 200/h',
    '3 anúncios leilão': '3 auction listings',
    '5 anúncios leilão': '5 auction listings',
    '10 anúncios leilão': '10 auction listings',
    'Taxa PIX 10%': 'PIX fee 10%',
    'Taxa PIX 5%': 'PIX fee 5%',
    'Taxa PIX 0%': 'PIX fee 0%',
    '3 cofres': '3 vaults',
    '4 cofres · juros +0,2%': '4 vaults · interest +0.2%',
    '5 cofres · juros +0,5%': '5 vaults · interest +0.5%',
    'Tag [Origin]': 'Tag [Origin]',
    'Tag [Eclipse]': 'Tag [Eclipse]',
    'Tag [Investidor]': 'Tag [Investor]',
    '/craft': '/craft',
    '/craft e /ec': '/craft and /ec',
    '/craft, /ec e /anvil': '/craft, /ec and /anvil',
    '1 efeito': '1 effect',
    '2 efeitos': '2 effects',
    '5 efeitos': '5 effects',
    'Salário 1.000/dia': 'Salary 1,000/day',
    'Salário 2.500/dia': 'Salary 2,500/day',
    'Salário 5.000/dia': 'Salary 5,000/day',
    'Kit mensal': 'Monthly kit',
    'Kit semanal premium': 'Weekly premium kit',
    '20% no baú do clã': '20% off clan chest',
    '40% no baú do clã': '40% off clan chest',
  },
  faq: [
    {
      q: 'How does renewal work?',
      a: 'With card (Stripe), billing is recurring — cancel via the portal in My account or on Discord. With PIX (Mercado Pago), payment covers only the chosen period; renew on the site before it expires.',
    },
    {
      q: 'Can I change plans?',
      a: 'Yes — talk to staff on Discord for an upgrade or downgrade.',
    },
    {
      q: 'What payment methods are accepted?',
      a: 'Card via Stripe (auto-renewal) or PIX via Mercado Pago (QR Code / copy-paste).',
    },
    {
      q: 'Are benefits immediate?',
      a: 'Yes. With card, after Stripe confirmation. With PIX, as soon as payment is approved (usually within seconds).',
    },
  ],
};
